<template>
  <BreadCrumb PageTitle="Modifier bon de reception" />
  <EditReturn  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditReturn from "@/components/Notes/Return/Client/EditReturn.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditReturnPage",
  components: {
    BreadCrumb,
    EditReturn,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let refNote = route.params.refNote; 
    if (Array.isArray(refNote)) {
      refNote = refNote[0] ?? "";
    }


    return { id , refNote};
}
});
</script>